import { Button, Stack, TextField, Typography } from "@mui/material";
import { MprcBoxDrawer } from "components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

export enum ReplyStatus {
    Approved = 1,
    Rejected = 2
}

export type ReplyDialogResult = {
    status: ReplyStatus;
    message: string | null;
};

interface IReplyProps {
    open: boolean;
    title: string | null;
    approveButtonText: string;
    rejectButtonText: string;
    onClose: (result: ReplyDialogResult | undefined) => void;
}

export const ReplyDrawer: React.FC<IReplyProps> = (props) => {

    const { open, title, approveButtonText, rejectButtonText, onClose } = props;
    const { t } = useTranslation("");
    const [text, setText] = useState<string | null>(null);

    return (
        <MprcBoxDrawer
            open={open}
            title={t("Common.ReplyDrawer.Title")}
            subtitle={title}
            onClose={() => onClose(undefined)}
            content={
                <>
                    <TextField
                        autoFocus
                        value={text}
                        placeholder={t("Common.ReplyDrawer.MessagePlaceholder")}
                        multiline={true}
                        rows={10}
                        onChange={(e) => setText(e.target.value)}
                        fullWidth
                        variant="outlined"
                        margin="normal"
                    />

                    <Stack direction="column" spacing={2} justifyItems="center">
                        <Typography variant="h4" textAlign="center">
                            {t("Common.ReplyDrawer.ActionTitle")}
                        </Typography>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => onClose({ status: ReplyStatus.Approved, message: text })}
                        >
                            {approveButtonText}
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => onClose({ status: ReplyStatus.Rejected, message: text })}
                        >
                            {rejectButtonText}
                        </Button>

                    </Stack>

                </>
            }
        />
    );
};